import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { Banner } from '../../admin/models/banner.model';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private readonly baseUrl = `${environment.ApiBaseUrl}/Banners`;

  constructor(private http: HttpClient) {}

  getActiveBanners(): Observable<Banner[]> {
    return this.http.get<Banner[]>(`${this.baseUrl}/active`);
  }
}
